import React from "react";
import ValidatedInputField from "../../common/form/ValidatedInputField";
import { Field } from "redux-form";
import ValidatedWrappedInputField from "../information/ValidatedWrappedInputField";
import normalizePNumber from "../../../normalizers/normalizePNumber";
import Municipality from "../Municipality";
import CompanyAddress from "../CompanyAddress";
import normalizePostalCode from "../../../normalizers/normalizePostalCode";
import Regions from "../Regions";
import normalizeCVR from "../../../normalizers/normalizeCVR";
import BlockFormWrapper from "../../common/form/BlockFormWrapper";
import FieldWrapper from "../information/FieldWrapper";
import GeoLocation from "../../common/GeoLocation";
import CompanyPhoneInput from "../CompanyPhoneInput";
import DropDownOptions from "../../helpers/DropDownOptions";
import ReactSelect from "../../common/ReactSelect";
import Wrapper from "../../common/form/Wrapper";
import * as subscriptionTypes from "../subscriptionType";

const CompanyInfoTabContent = props => {
    const {
        labels,
        messages,
        initialValues,
        isAdmin,
        countries,
        regions,
        municipalities,
        addressSearchResult
    } = props;

    return (
        <div>
            <BlockFormWrapper title={labels.companyGeneralInfo}>
                <FieldWrapper label={labels.country} inputCol={3}>
                    <Field
                        type="select"
                        name="countryId"
                        component={ReactSelect}
                        options={DropDownOptions.getOptions(
                            countries,
                            "id",
                            "name"
                        )}
                    />
                </FieldWrapper>
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label">
                        <b>{labels.region}</b>
                    </label>
                    <div className="col-sm-10" data-cy-company-region>
                        <Field
                            name="regionId"
                            component={Regions}
                            regions={regions}
                        />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label">
                        <b>{labels.municipality}</b>
                    </label>
                    <div className="col-sm-10" data-cy-company-municipality>
                        <Field
                            name="municipalityId"
                            component={Municipality}
                            municipalities={municipalities}
                        />
                    </div>
                </div>
            </BlockFormWrapper>
            <BlockFormWrapper title={labels.address}>
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label">
                        <b>{labels.address}</b>
                    </label>
                    <div className="col-sm-10" data-cy-company-address>
                        <Field
                            name="addressId"
                            component={CompanyAddress}
                            addressSearchResult={addressSearchResult}
                            regionId={initialValues.regionId}
                            municipalityId={initialValues.municipalityId}
                            addressPreLoaded={initialValues.addressPreLoaded}
                            addressId={initialValues.addressId}
                        />
                    </div>
                </div>
                <Field
                    className="form-control"
                    name="city"
                    type="text"
                    component={ValidatedWrappedInputField}
                    label={labels.city}
                />
                <FieldWrapper label={labels.postalCode}>
                    <div className={"row"}>
                        <div className="w-3 ml-2 pt-2">DK</div>
                        <div className="col-xs col-sm-4 col-xl-2">
                            <Field
                                className="form-control"
                                name="postalCode"
                                component={"input"}
                                type="text"
                                placeholder="XXXX"
                                normalize={normalizePostalCode}
                            />
                        </div>
                    </div>
                </FieldWrapper>
                <div className="form-group row mt-2">
                    <label className="col-sm-2">
                        <b>{labels.showAddressOnMap}</b>
                    </label>
                    <div className="col-sm-10">
                        <label className="custom-control custom-checkbox">
                            <Field
                                name="showOnGoogleMaps"
                                type="checkbox"
                                component="input"
                                className="custom-control-input"
                            />
                            <span className="custom-control-indicator"> </span>
                        </label>
                    </div>
                </div>
                <div className="form-group row mt-2">
                    <label className="col-sm-2">
                        <b>Skjul adresse overalt</b>
                    </label>
                    <div className="col-sm-10">
                        <label className="custom-control custom-checkbox">
                            <Field
                                name="hideAddressEverywhere"
                                type="checkbox"
                                component="input"
                                className="custom-control-input"
                            />
                            <span className="custom-control-indicator"> </span>
                        </label>
                    </div>
                </div>
                <GeoLocation
                    addressId={initialValues.addressId}
                    latitude={initialValues.latitude}
                    longitude={initialValues.longitude}
                />
            </BlockFormWrapper>
            <BlockFormWrapper title={labels.companyIdentification}>
                <FieldWrapper
                    label={
                        <span>
                            {labels.cvrNumber}{" "}
                            <span className="text-muted">
                                {" " + messages.optional}
                            </span>
                        </span>
                    }
                >
                    <div className={"row"}>
                        <div className="ml-2 w-3 pt-2">DK</div>
                        <div className="col-xs col-sm-4 col-xl-2">
                            <Field
                                className="form-control"
                                name="cvr"
                                component={ValidatedInputField}
                                type="text"
                                placeholder="XXXXXXXX"
                                normalize={normalizeCVR}
                            />
                        </div>
                    </div>
                </FieldWrapper>
                <FieldWrapper
                    label={
                        <span>
                            {labels.companyPhoneNumber}
                            <span className="text-muted">
                                {" " + messages.optional}
                            </span>
                        </span>
                    }
                >
                    <div className={"row"}>
                        <div className="ml-2 w-3" />
                        <div className="col-xs col-sm-4 col-xl-2">
                            <Field
                                className="form-control"
                                name="pNumber"
                                component={ValidatedInputField}
                                type="text"
                                placeholder="XXXXXXXX"
                                normalize={normalizePNumber}
                            />
                        </div>
                        <div className="row">
                            <div className="ml-2 w-3">&nbsp;</div>
                            <div className="col-xs col-sm-10">
                                {labels.companyCvrNumberDescription}
                            </div>
                        </div>
                    </div>
                </FieldWrapper>
            </BlockFormWrapper>
            <BlockFormWrapper title={labels.companyContactOptions}>
                <FieldWrapper
                    label={
                        <span>
                            Telefon{" "}
                            <span className="text-muted">
                                {" " + messages.optional}
                            </span>
                        </span>
                    }
                >
                    <Field
                        className="form-control"
                        name="phoneNumber"
                        component={CompanyPhoneInput}
                        type="tel"
                        placeholder="XXXXXXXX"
                    />
                </FieldWrapper>
                <FieldWrapper
                    label={
                        <span>
                            {" "}
                            {labels.fax}
                            <span className="text-muted">
                                {" " + messages.optional}
                            </span>
                        </span>
                    }
                >
                    <Field
                        className="form-control"
                        name="faxNumber"
                        component={CompanyPhoneInput}
                        type="tel"
                        placeholder="XXXXXXXX"
                    />
                </FieldWrapper>
                <Field
                    className="form-control"
                    name="email"
                    type="text"
                    component={ValidatedWrappedInputField}
                    label={
                        <span>
                            {labels.email}
                            <span className="text-muted">
                                {" " + messages.optional}
                            </span>
                        </span>
                    }
                    props={{
                        placeholder: labels.email
                    }}
                />
                <Field
                    className="form-control"
                    name="homepage"
                    type="text"
                    component={ValidatedWrappedInputField}
                    label={
                        <span>
                            {labels.companyHomePage}
                            <span className="text-muted">
                                {" " + messages.optional}
                            </span>
                        </span>
                    }
                    props={{
                        placeholder: labels.companyHomePage
                    }}
                />
            </BlockFormWrapper>
            <BlockFormWrapper title={labels.socialMediaLinks}>
                {[
                    {
                        name: "facebook",
                        showedName: "Facebook",
                        icon: "fa fa-facebook-official"
                    },
                    {
                        name: "linkedin",
                        showedName: "LinkedIn",
                        icon: "fa fa-linkedin"
                    },
                    {
                        name: "twitter",
                        showedName: "Twitter",
                        icon: "fa fa-twitter"
                    },
                    {
                        name: "instagram",
                        showedName: "Instagram",
                        icon: "fa fa-instagram"
                    }
                ].map(function(item, key) {

                    let checkboxFBFeed = (
                        <Wrapper>
                            <label className="custom-control custom-checkbox">
                                <Field
                                    name="showFacebookFeed"
                                    type="checkbox"
                                    component="input"
                                    className="custom-control-input"
                                />
                                <span className="custom-control-indicator"> </span>
                                <span className="custom-control-description">
                                    Vis Facebook feed på min profilside
                                </span>
                            </label>
                        </Wrapper>
                    );

                    return (
                        <div key={key}>
                            <Field
                                className="form-control"
                                name={item.name}
                                type="text"
                                component={ValidatedWrappedInputField}
                                label={
                                    <span>
                                        <i className={item.icon} />{" "}
                                        {item.showedName}
                                        <span className="text-muted">
                                            {" " + messages.optional}
                                        </span>
                                    </span>
                                }
                                placeholder={item.showedName}
                            />
                            {
                                initialValues.subscriptionType != subscriptionTypes.MASKINSTATIONER_MINI
                                && (item.name == "facebook") && checkboxFBFeed
                            }
                        </div>
                    );
                })}
            </BlockFormWrapper>
            <BlockFormWrapper title={labels.other}>
                <FieldWrapper
                    label={
                        <span>
                            Ansatte{" "}
                            <span className="text-muted">
                                {" " + messages.optional}
                            </span>
                        </span>
                    }
                    inputCol={2}
                >
                    <Field
                        className="form-control"
                        name="employeeCount"
                        component="input"
                        type="number"
                        min="1"
                    />
                </FieldWrapper>
            </BlockFormWrapper>
        </div>
    );
};

export default CompanyInfoTabContent;



// WEBPACK FOOTER //
// ./web/src/components/company/company-form/CompanyInfoTabContent.jsx